import React, { Component } from 'react'
import Dialog from 'react-bootstrap-dialog'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Loader from 'react-loader-advanced'
//import * as Constants from '../../../../common/constants'
//import { employeesTableReady } from '../../redux/employees'
import { buildNumberUpdate } from '../../../../redux/user'
//import apiService from '../../services/apiservices'

//import * as Helpers from '../../../../common/helpers'


    function csvToJsonFn(csv) {

         let lines=csv.split("\r\n");

          let result = [];

          // NOTE: If your columns contain commas in their values, you'll need
          // to deal with those before doing the next step 
          // (you might convert them to &&& or something, then covert them back later)
          // jsfiddle showing the issue https://jsfiddle.net/
          let headers=lines[0].split(",");

          for(let i=1;i<lines.length-1;i++){

              let obj = {};
              let currentline=lines[i].split(",");

              for(let j=0;j<headers.length;j++){
                  obj[headers[j]] = currentline[j];
              }

              result.push(obj);

          }

          //return result; //JavaScript object
          return result; //JSON

    };

class ImportEmployeesModalLayout extends Component {
    constructor() {
        super()
        this.state = {
            reasons: {},
            isUpdating: false,

            quantityErrorText: false,
            quantityErrorData: '',
            file:'',
        }
        this.dialog = null

        this.reasonText = ""

        this.remarks = null

        this.isComponentStillMount = true
        this.createYesComponent = null

        this.quantityComponent = null
        this.quantitySection = null
    }

    componentWillMount() {
        this.isComponentStillMount = true
    }

    componentDidMount() {
        //this.props.dispatch(employeesTableReadyStatus(false))
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    componentWillUnmount() {
        this.isComponentStillMount = false
    }

    isCreateAgain = () => {
        if(this.createYesComponent.checked){
            this.setState({ isCreateAgain: true })
        }else{
            this.setState({ isCreateAgain: false })
        }
        
    }

    handleChanges = () => {
    }

    submitData = () => {
        let data = {}
        data.create_again=0
        
        
        }


    onFinish = () => {
        this.props.history.goBack()
    }

    handleOnChange = (e) => {
   
        this.setState({
           file : e.target.files[0] 
        });
    };


    

    handleOnSubmit = (e) => {

        e.preventDefault();

        if (this.state.file) {
            const fileReader = new FileReader();

            fileReader.onload = function (event) {
                const csvOutput = event.target.result;
                // const jsonOutput = csvToJsonFn(csvOutput);
                csvToJsonFn(csvOutput);
                debugger;
            };

            fileReader.readAsText(this.state.file);
        }
    };



  
    render() {

        return (
            <div className="qr-code-reader-modal">
                <Dialog ref={el => this.dialog = el} />
                <Loader
                    show={this.state.isUpdating}
                    message={'Updating...Please wait'}
                    foregroundStyle={{ color: "#ffffff", fontSize: "17px", fontWeight: "600" }}>
                    <div className="modal-header">
                        <button type="button" className="close"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>
                            <span>&times;</span></button>
                        <h4 className="modal-title">Import Employees</h4>
                    </div>

                    <div className="modal-body">
                        <div className="form-horizontal">

                          <div className="col-md-12 col-sm-12 col-xs-12">
                
                                <div className="form-group">
                                <label className="col-sm-3 control-label labels" style={{textAlign: "right", paddingTop: "0px"}}>Select CSV file</label>
                     <div className="col-sm-9">
                                        <input
                                          type={"file"}
                                          id={"csvFileInput"}
                                          accept={".csv"}
                                          onChange={this.handleOnChange}
                                        />
                                            </div>
                                        </div>
                                </div>
                             </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary pull-left"
                            onClick={(e) => {
                                e.preventDefault()
                                this.props.closeModal(false)
                            }}>Close</button>
                            <button
                                    className="btn btn-info pull-right"
                                    style={{ width: "auto" }}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.handleOnSubmit(e);
                                    }} >
                                    Import
                                </button>
                    </div>

            </Loader>
            </div>
        )
    }


    keyedInputChange = (keyedName) => {
        console.log(keyedName)
        let keyedComponent =keyedName+"Component"
        let keyedErrorText =keyedName+"ErrorText"
        let keyedErrorData =keyedName+"ErrorData"
        let keyedSection =keyedName+"Section"
        let name=this[keyedComponent].value.trim()
        this.setState({[keyedName]:name})
        if(!name){
            this.setState({[keyedName] : null})
            return
        }
        this.setState({ [keyedErrorText]: false, [keyedErrorData]: '' })
        this[keyedSection].className = this[keyedSection].className.replace(" has-error", "")
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        orders: state.orders,
    }
}

export default connect(mapStateToProps)(withRouter(ImportEmployeesModalLayout))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/EmployeeModalLayout/ImportEmployeesModalLayout.js